import { render, staticRenderFns } from "./BidSuppList.vue?vue&type=template&id=5df0a2c8&"
import script from "./BidSuppList.vue?vue&type=script&lang=js&"
export * from "./BidSuppList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports